const carouselItems = [
  {
    id: 1,
    tag: '本周热门',
    title: '穿越重生韩漫专题',
    desc: '一觉醒来变成小说反派？穿越重生类韩漫精选合集，从宫廷斗争到现代职场逆袭，每一部都让你欲罢不能。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20fantasy%20character%20in%20traditional%20Korean%20hanbok%20standing%20in%20a%20palace%20with%20magical%20elements%2C%20warm%20golden%20and%20coral%20color%20palette%2C%20dramatic%20composition%2C%20clean%20art%20style%2C%20editorial%20quality&width=800&height=500&seq=carousel-01-rebirth&orientation=landscape',
    stat: '2,847人在读',
  },
  {
    id: 2,
    tag: '新番上线',
    title: '2026夏季新连载推荐',
    desc: '本季最新上线的韩漫作品大盘点！从校园恋爱到悬疑惊悚，精选10部口碑新作，抢先体验最新连载。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20style%20illustration%20of%20young%20students%20in%20a%20university%20campus%20setting%20with%20cherry%20blossoms%2C%20fresh%20summer%20aesthetic%2C%20warm%20coral%20and%20soft%20peach%20tones%2C%20clean%20editorial%20style&width=800&height=500&seq=carousel-02-new&orientation=landscape',
    stat: '1,203人在读',
  },
  {
    id: 3,
    tag: '完结佳作',
    title: '口碑韩漫·完结精选',
    desc: '已完结高分韩漫合集，不用担心追更断更，一口气看到大结局。涵盖全品类，评分9.0以上的必看之作。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20illustration%20of%20a%20couple%20in%20a%20beautiful%20night%20cityscape%20with%20warm%20street%20lights%2C%20emotional%20atmosphere%2C%20soft%20coral%20and%20golden%20warm%20tones%2C%20cinematic%20composition%2C%20high%20quality&width=800&height=500&seq=carousel-03-completed&orientation=landscape',
    stat: '5,621人已追完',
  },
  {
    id: 4,
    tag: '独家专题',
    title: '韩漫入门必读指南',
    desc: '第一次看韩漫不知道从哪开始？我们为你整理了韩漫入门必读清单，涵盖各类型代表作，帮你快速找到心仪的作品。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20fantasy%20illustration%20with%20dynamic%20character%20posing%20in%20an%20epic%20battle%20scene%2C%20vibrant%20coral%20and%20golden%20color%20scheme%2C%20clean%20modern%20art%20style%2C%20dramatic%20lighting%2C%20editorial%20quality&width=800&height=500&seq=carousel-04-guide&orientation=landscape',
    stat: '8,930人在读',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            热门推荐
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[560px] mx-auto">
            精选当下最受关注的韩漫专题，热门连载、新番上线、完结佳作一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300/40 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center px-3 py-1 bg-primary-500/90 backdrop-blur-sm text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2 mb-3">
                  {item.desc}
                </p>
                <div className="flex items-center gap-1.5 text-foreground-500">
                  <i className="ri-eye-line text-sm"></i>
                  <span className="text-xs">{item.stat}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}